// extracted by mini-css-extract-plugin
export var fadeIn = "_ik-1";
export var modalContent = "_ik-3";
export var overlay = "_ik-0";
export var popoverContent = "_ik-2";
export var results = "_ik-5";
export var searchInputWrapper = "_ik-4";